export default {
    methods: {
        mixFloatInput: function(input) {
            return /(^\d*\.?\d*$)/.test(input)
        },
        mixCheckFloat: function(input) {
            let dot = false
            let arr = input.split('')
            arr = arr.filter(char => {
                if (/\./.test(char)) {
                    if (!dot) {
                        dot = true
                        return true
                    } else {
                        return false
                    }
                } else if (/\d/.test(char)) {
                    return true
                } else {
                    return false
                }
            })
            let result = arr.join('')
            return result
        },
        mixProcessFloat: function(input) {
            if (this.mixFloatInput(input))
                this.$nextTick(() => {
                    return this.mixCheckFloat(input)
                })
        },
    },
}
